import { AztecAddress } from "@aztec/aztec.js";
import { persistentAtom } from "@nanostores/persistent";
import type { Address } from "viem";
import { deserialize, serialize } from "wagmi";
import { LocalStorageKeys } from "./keys";

const $shieldingUserAddedTokensAtom = persistentAtom<AztecAddress[]>(LocalStorageKeys.SHIELDING_USER_ADDED_TOKENS, [], {
  encode: serialize,
  decode: deserialize,
});

export function getShieldingUserAddedTokens(): AztecAddress[] {
  return $shieldingUserAddedTokensAtom.get();
}

export function addShieldingUserAddedTokens(l2TokenAddress: string) {
  const tokens = getShieldingUserAddedTokens();
  const data = tokens.concat(AztecAddress.fromString(l2TokenAddress as Address));
  $shieldingUserAddedTokensAtom.set(data);
}
